import { useState, useEffect } from 'react';

/**
 * Hook per gestire la modalità debug globale.
 * Attiva/disattiva premendo Ctrl+Shift+D (o Cmd+Shift+D su Mac)
 */
export const useDebugMode = () => {
  const [debugMode, setDebugMode] = useState(false);

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      // Ctrl+Shift+D (o Cmd+Shift+D su Mac)
      if ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'D') {
        event.preventDefault();
        setDebugMode((prev) => {
          const newMode = !prev;
          console.log(`🔧 DEBUG MODE: ${newMode ? 'ON' : 'OFF'}`);
          if (newMode) {
            console.log('💡 Click sulla scena per ottenere le coordinate degli Hotspot');
          }
          return newMode;
        });
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  return debugMode;
};
